import type { PickedCloudFile } from './types'

export const CLOUD_DOWNLOAD_FAILURES = [
  'cannot-connect',
  'timed-out',
  'dropped',
  'not-found',
  'forbidden',
  'rate-limited',
  'server-error',
  'unexpected-status',
  'not-pdf',
  'size-mismatch',
  'unknown-size',
  'too-large',
  'too-many-at-once',
  'unexpected',
] as const

export type CloudDownloadFailure = (typeof CLOUD_DOWNLOAD_FAILURES)[number]

// The message names only the failure, never the link: a provider link opens the customer file.
export class CloudDownloadError extends Error {
  readonly failure: CloudDownloadFailure

  constructor(failure: CloudDownloadFailure) {
    super(`Cloud file download failed: ${failure}`)
    this.name = 'CloudDownloadError'
    this.failure = failure
  }
}

export const failureOf = (error: unknown): CloudDownloadFailure =>
  error instanceof CloudDownloadError ? error.failure : 'unexpected'

// A file the provider listed but will not hand over: its download fails with the reason.
export const failingPickedFile = (
  { name, size }: Pick<PickedCloudFile, 'name' | 'size'>,
  failure: CloudDownloadFailure,
): PickedCloudFile => ({
  name,
  size,
  download: () => Promise.reject(new CloudDownloadError(failure)),
})
